import { START_LOADING, DONE_LOADING } from './actions';

export default (state = {}, { type, loadingItem = 'unspecified' }) => {
  switch (type) {
    case START_LOADING:
      return {
        ...state,
        [loadingItem]: true,
      };
    case DONE_LOADING:
      return {
        ...state,
        [loadingItem]: false,
      };
    default:
      return state;
  }
};
